<template>
	<div>
		<TableList :scroll="{x:2000}" :form_data_seo.sync="form_data_seo" :columns="columns"
			:get_table_list="this.get_table_list"
			:slot_table_list="['status','operation','work_time','factory_name','station_num','tolerance','time','update_time']"
			:submit_preprocessing="submit_preprocessing" ref="list">
			<template slot="left_btn">
				<a-button class="float_left" @click="edit" type="primary">新增</a-button>
				<a-button class="float_left" @click="getPeakConfigFun">旺季配置</a-button>
			</template>
			<template slot="operation" slot-scope="data">
				<p>
					<span>
						<a @click='see_rule(data.record)'>
							查看
						</a>
						<a-divider type="vertical" />
						<a @click='edit(data.record)'>
							编辑
						</a>
						<a-divider type="vertical" />

						<a style="background: none" :class='data.record.status==1?"infocan2":"infocan"'
							@click='changStatus(data.record)'>

							{{data.record.status==1?'禁用':'启用'}}
						</a>
					</span>
				</p>
			</template>
			<template slot="station_num" slot-scope="data">
				<p>
					<span>
						<a @click='goUser(data.record)'>
							{{data.record.station_num}}
						</a>
					</span>
				</p>
			</template>
			<template slot="factory_name" slot-scope="data">
				<p>
					<span>
						<a @click='see_rule(data.record)'>
							{{data.record.factory_name}}
						</a>
					</span>
				</p>
				<p>ID:{{data.record.factory_id}}</p>
			</template>
			<template slot="work_time" slot-scope="data">
				<p :class='it.type!=1?"nowTime":"wTime"' v-for='(it,key) in data.record.frequency'>
					{{it.text}}
				</p>
			</template>
			<template slot="tolerance" slot-scope="data">
				<p>
					{{data.record.tolerance}}分钟
				</p>
			</template>
			<template slot="time" slot-scope="data">
				<div v-if='data.record.off_night_start'>
					<p>
						白班:{{data.record.off_day_start}}-{{data.record.off_day_end}}
					</p>
					<p>
						晚班:{{data.record.off_night_start}}-{{data.record.off_night_end}}
					</p>
				</div>

				<div v-else>
					{{data.record.off_day_start}}-{{data.record.off_day_end}}
				</div>


			</template>
			<template slot="update_time" slot-scope="data">
				<p>
					创建:{{data.record.create_time}}
				</p>
				<p>
					更新:{{data.record.update_time}}
				</p>

			</template>


			<template slot="busy_season_time" slot-scope="data">
				<p>
					<span v-if='data.record.is_busy_season==1'>
						{{data.record.busy_season_time}}月
					</span>
					<span v-else>
						未设置旺季
					</span>
				</p>
			</template>

			<template slot="status" slot-scope="data">

				<p :class='data.record.status==1?"can":"nocan"'>
					{{data.record.status==1?'生效中':'禁用'}}
				</p>
			</template>
			<template slot="use_num" slot-scope="data">
				<p>
					<span>
						<a @click='see_user(data.record)'>
							{{data.record.use_num}}
						</a>
					</span>
				</p>

			</template>
			<template slot="execute_end_time" slot-scope="data">
				<p v-if='data.record.is_busy_season==1'>
					<span>
						旺季白班：{{data.record.busy_day_start_time}}~{{data.record.busy_day_start_time}}
					</span>
				</p>
				<p>
					<span>
						淡季白班：{{data.record.day_start_time}}~{{data.record.day_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season!=1'>
					<span>
						晚班：{{data.record.night_start_time}}~{{data.record.night_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season==1'>
					<span>
						淡季晚班：{{data.record.night_start_time}}~{{data.record.night_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season==1'>
					<span>
						旺季晚班：{{data.record.busy_night_start_time}}~{{data.record.busy_night_end_time}}
					</span>
				</p>
			</template>
		</TableList>

		<a-modal title="查看规则" width='30%' :maskClosable='true' :visible="see_visible" @cancel='see_visible=false'
			@ok='see_visible=false'>
			<div>
				<a-descriptions :column='2'>
					<a-descriptions-item label="工厂名称">
						{{see_info.factory_name}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂ID">
						{{see_info.id}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂地址">
						{{see_info.address}}
					</a-descriptions-item>
					<a-descriptions-item label="打卡半径">
						{{see_info.radius}}米
					</a-descriptions-item>

				</a-descriptions>
				
				
				<div v-if='see_info.night_open==1&&see_info.peak_open==0'>
					
					<a-alert class="mt10" message="打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						
						<div >
							<p class="mt10"><span
									class="red">*</span><span>白班上班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
							</p>
						</div>
						<div >
							<p class="mt10"><span
									class="red">*</span><span>晚班上班时间：{{see_info.off_night_start}}~{{see_info.off_night_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>打卡频率：<span>每{{see_info.peak_frequency}}小时打卡1次</span></span></p>
					</div>
				</div>
				<div v-else>
					<a-alert class="mt10" message="旺季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						<div v-if='see_info.off_night_start'>
					
							<p class="mt10"><span
									class="red">*</span><span>旺季白班时间：{{see_info.peak_day_sta}}~{{see_info.peak_day_end}}</span>
							</p>
							<p class="mt10"><span
									class="red">*</span><span>旺季晚班时间：{{see_info.peak_night_start}}~{{see_info.peak_night_end}}</span>
							</p>
						</div>
						<div v-else>
							<p class="mt10"><span
									class="red">*</span><span>上班时间：{{see_info.peak_day_start}}~{{see_info.peak_day_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>旺季打卡频率：<span>每{{see_info.peak_frequency}}小时打卡1次</span></span></p>
					</div>
					
					<a-alert class="mt10" message="淡季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						<div v-if='see_info.off_night_start'>
						<p class="mt10"><span
								class="red">*</span><span>淡季白班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
						</p>
						<p class="mt10"><span
								class="red">*</span><span>淡季晚班时间：{{see_info.off_night_start}}~{{see_info.off_night_end}}</span>
						</p>
						</div>
						<div v-else>
							<p class="mt10"><span
									class="red">*</span><span>上班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>淡季打卡频率：<span>每</span>{{see_info.off_frequency}}<span>小时打卡1次</span></span>
						</p>
					</div>
				</div>
			
				<a-alert class="mt10" message="其他规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>
				<div class="mt10">
					<p class="mt10"><span class="red">*</span><span>容错窗口：前后{{see_info.tolerance}}分钟</span></p>
					<p class="mt10">容错期内打卡视为合规，超出容错期，则不可打卡</p>
				</div>

			</div>
		</a-modal>

		<a-modal title="季节规则配置" width='30%' :maskClosable='true' :visible="busy_season_visible"
			@cancel='busy_season_visible=false' @ok='busy_season_fun()'>
			<p class="flex_box"><span>旺季时间:</span> <a-select style="width: 80%"
					:dropdown-style="{ maxHeight: '300px', overflow: 'auto' }" ref="select" mode="multiple"
					v-model:value="busy_season_time">
					<a-select-option :value="month" v-for='month in 12' :key='month'>{{month}}月</a-select-option>
				</a-select></p>
		</a-modal>


		<a-modal title="禁用提示" width='30%' :maskClosable='true' :visible="status_visible" @cancel='status_visible=false'
			@ok='changeStatus'>
			<div style="text-align: center;width:80%;margin: 0 auto;">
				<p v-if='chooseinfo.status==1&&chooseinfo.station_num>0'>当前工厂存在 <span
						style='color: #1890ff;'>正在驻场人员{{chooseinfo.station_num}}个</span>，
					请先前往“驻场人员”解除后，再禁用当前工厂规则</p>
				<p v-if='chooseinfo.status==1&&chooseinfo.station_num==0'>是否确认禁用当前工厂“驻场规则”，
					禁用后，新增人员驻场时，将无法选择当前工厂进行驻场。</p>
				<p v-if='chooseinfo.status==-1'>是否确认启用当前工厂“驻场规则”，
					启用后，新增人员驻场时，可选择当前工厂驻场。</p>
			</div>
		</a-modal>


		<supInfo :visible.sync="drawer_visible"></supInfo>


	</div>
</template>
<script>
	import {
		user_index
	} from "@/api/user";

	import Form from "@/components/Form";
	import TableList from "@/components/TableList";

	import TransferTree from "@/components/TransferTreeTwo";
	import supInfo from "@/views/supervision/supInfo.vue";
	import {
		message
	} from 'ant-design-vue';
	import {
		getList,
		saveRuleInfo,
		getRuleDetail,
		changeRuleStatus,
		delRule,
		getPeakConfig,
		savePeakConfig
	} from "@/api/dispatch";

	let columns = [{
			title: "工厂名称",
			dataIndex: "factory_name",
			scopedSlots: {
				customRender: "factory_name"
			}
		},
		{
			title: "当前驻场（人）",
			dataIndex: "station_num",
			scopedSlots: {
				customRender: "station_num"
			}
		},
		{
			title: "打卡地址",
			dataIndex: "address",
			width: 250,

		},

		{
			title: "打卡半径",
			dataIndex: "radius",

		},
		{
			title: "打卡频率",
			dataIndex: "work_time",
			scopedSlots: {
				customRender: "work_time"
			},
			width: 180,

		},
		{
			title: "容错窗口",
			dataIndex: "tolerance",
			scopedSlots: {
				customRender: "tolerance"
			}

		},
		{
			title: "工作时间",
			dataIndex: "time",
			scopedSlots: {
				customRender: "time"
			},
			width: 150,
		},

		{
			title: "状态",
			dataIndex: "status",
			scopedSlots: {
				customRender: "status"
			},
			width: 150,
		},
		{
			title: "时间",
			dataIndex: "update_time",
			scopedSlots: {
				customRender: "update_time"
			},
			width: 240,
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			},
					fixed: 'right',
			width: 200,
		},
	];

	export default {
		name: "gpoodIndex",
		components: {
			Form,
			TableList,
			TransferTree,
			supInfo
		},
		data() {
			return {
				chooseinfo: {},
				status_visible: false,
				busy_season_time: null,
				see_info: {},
				see_visible: false,
				drawer_visible: false,
				where: {
					rule_id: ''
				},
				execute_start_time: '',
				execute_end_time: '',
				treeData: [],
				rule_user: [],
				treeDataValue: [],
				top_count: [],
				get_user_list: user_index,
				get_table_list: getList,
				columns,
				treeDataValue: [],
				visible: false,
				visible_see: false,
				busy_season_visible: false,
				form_data_seo: {
					list: [{
							type: 'text',
							name: 'factory_name',
							placeholder: '请输入工厂名称',
							title: '工厂名称',
						},
						{
							type: 'text',
							name: 'factory_id',
							placeholder: '请输入工厂id',
							title: '工厂ID',
						},
						{
							type: 'select',
							name: 'status',
							placeholder: '请选择',
							title: '状态',
							list: [{
									key: '',
									value: '全部'
								}, {
									key: 1,
									value: '生效中'
								}, {
									key: -1,
									value: '禁用中'
								},

							],
						},
						{
							type: 'select',
							name: 'peak_open',
							placeholder: '请选择',
							title: '启用旺季',
							list: [{
									key: '',
									value: '全部'
								}, {
									key: 1,
									value: '是'
								}, {
									key: 0,
									value: '否'
								},

							],
						},
						{
							type: 'select',
							name: 'night_open',
							placeholder: '请选择',
							title: '启用晚班',
							list: [{
									key: '',
									value: '全部'
								}, {
									key: 1,
									value: '是'
								}, {
									key: 0,
									value: '否'
								},

							],
						},

					],
					...this.$config.form_data_seo
				},
				submit_preprocessing: {
					array_to_string: ['goods_name']
				}
			};
		},
		async created() {

		},
		methods: {
			getPeakConfigFun() {
				getPeakConfig().then(res => {
					this.busy_season_visible = true
					this.busy_season_time = res.data.peak_months
				})
			},
			busy_season_fun() {
				savePeakConfig({
					data: {
						peak_months: this.busy_season_time.join(',')
					},
					info: true,
				}).then(res => {

				})
				this.busy_season_visible = false
			},
			changStatus(info) {
				this.status_visible = true
				this.chooseinfo = info
			},
			see_rule(data) {
				getRuleDetail({
					data: {
						id: data.id
					}
				}).then(res => {
					this.see_info = res.data
					this.see_visible = true
				})
			},
			show() {
				this.drawer_visible = true;
			},
			see_user(data) {
				this.visible_see = true
				this.where.rule_id = data.id
				this.$nextTick(res => {
					this.$refs.pop_table_list.set_data('fixed_seo_data', {
						rule_id: data.id
					})
					this.$refs.pop_table_list.get_list();
				})
			},
			TransferTreeChange(value) {
				this.rule_user = value.join(',')
			},
			changeStatus(data) {
				if(this.chooseinfo.station_num==0){
					changeRuleStatus({
						data: {
							id: this.chooseinfo.id,
							status: this.chooseinfo.status == -1 ? 1 : -1
						}
					}).then(res => {
						this.$refs.list.get_list();
						this.status_visible = false
					})
				}else{
					this.status_visible = false
				}
				
				
				
			},

			edit(record) {
				this.$router.push({
					path: 'edit',
					query: {
						id: record.id ? record.id : ''
					}

				})
			},

			goUser(record) {
				this.$router.push({
					path: 'user',
					query: {
						factory_id: record.factory_id ? record.factory_id : ''
					}

				})
			},
			del(record) {
				delRule({
					data: {
						id: record.id
					},
					info: true,
				}).then(res => {
					this.$refs.list.get_list();
				})
			},
			submit(e) {
				let data = e.values;
				if (!data.id) {
					data.id = '';
				}

				saveRuleInfo({
					data: {
						...data,
						execute_end_time: this.execute_end_time,
						execute_start_time: this.execute_start_time,
						rule_user: this.rule_user
					},
					info: true,
				}).then(res => {
					this.visible = false;
					this.$refs.list.get_list();
				})
			},

		}
	};
</script>

<style lang="less">
	@import url("../../assets/less/app.less");

	.max_price_tips {
		margin-left: 99px;
		margin-top: -30px;
		font-size: 13px;
	}

	.float_left {
		margin-right: 8px;
	}



	.info_item {
		display: flex;
		font-size: 16px;
		line-height: 35px;

		span {
			flex: 2;
			text-align: right;
		}

		span:nth-child(2) {
			flex: 3;
			text-align: left;
			margin-left: 10px;
		}
	}

	/deep/ .ant-alert-message {
		color: #1890ff;
	}


	/deep/ .ant-alert-icon {
		top: 10px;
	}

	.wTime {
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nowTime {
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #FDF6EA;
		color: #B97104;
		text-align: center;
	}

	.can {
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nocan {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #FCE6E3;
		color: #F93317;
		text-align: center;
	}

	.infocan {
		coloe: #1890ff;
	}

	.infocan2 {
		color: #F93317;
	}

	.red {
		color: #F93317;
	}

	.flex_box {
		display: flex;
		align-items:center;
		
	}
</style>